export { default } from './CardContent';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/CardContent/index.js
// module id = 659
// module chunks = 0